'use client'
import type { WidgetBlog, StorefrontWidget } from 'ecosystem'
import { useGenericRequest } from 'api'
import { useCallback, useEffect } from 'react'

const useBlogPostsBySlugRequest = (endpointPath: string, slugs?: string[]) => {
  // Use POST method, because queryParams are limited and there might be too many `slugs`
  const { fetchNextRoute, error, data, isLoading } = useGenericRequest<{
    widgets: StorefrontWidget<WidgetBlog>[]
  }>()

  const fetchData = useCallback(() => {
    if (slugs?.length) {
      fetchNextRoute(endpointPath, {
        method: 'POST',
        body: JSON.stringify(slugs)
      })
    }
  }, [endpointPath, fetchNextRoute, slugs])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    data: data?.widgets,
    error,
    isLoading
  }
}

export default useBlogPostsBySlugRequest
